import React, { useState } from "react";
import styles from "./OurStory.module.css";
import { Link } from "react-router-dom";

const numberStats = [
  { number: "11", label: "Units" },
  { number: "2", label: "Locations" },
  // { number: "60+", label: "Rooms" },
];

const OurStory = () => {
  const [hoveredIndex, setHoveredIndex] = useState(null);

  return (
    <section className={styles.section}>
      <div className={styles.container}>
        {/* Left Text */}
        <div className={styles.text}>
          <h2 className={styles.title}>Our Story</h2>
          <p className={styles.description}>
            At Aurellia Hospitality, our journey began with a simple vision: to
            create a home away from home where luxury meets warmth. Founded with
            a passion for redefining hospitality, we set out to craft
            experiences that go beyond just accommodation, offering comfort,
            elegance, and personalized service tailored to every guest. From our
            first boutique residence to our expanding portfolio of premium
            stays, our commitment has remained the same: to provide exceptional
            hospitality that leaves lasting memories.
          </p>

          <Link to="/residencies">
            <button className={styles.button}>Explore Aurelia</button>
          </Link>
        </div>

        {/* Right Stats */}
        <div className={styles.numbers}>
          {numberStats.map((stat, index) => {
            const isHovered = hoveredIndex === index;
            const isOtherHovered = hoveredIndex !== null && !isHovered;
            const showLabel = window.innerWidth <= 768 || isHovered;

            return (
              <div
                key={index}
                className={styles.stat}
                onMouseEnter={() => setHoveredIndex(index)}
                onMouseLeave={() => setHoveredIndex(null)}
                style={{
                  flex: isHovered ? 5 : isOtherHovered ? 2.5 : 1,
                  borderLeft: index === 1 ? "1px solid #000" : "none",
                  // borderRight: index === 1 ? "1px solid #000" : "none",
                }}
              >
                <div>
                  <h1>{stat.number}</h1>
                </div>
                {showLabel && <p>{stat.label}</p>}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default OurStory;
